import React, { useEffect, useState } from 'react'
import TaxForm from '../../components/Forms/Tax/TaxForm'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import { useTax } from '../../hooks/CompanyConfiguration/useTax'
import { ROUTES } from '../../shared/constants'

export default function AddTax({ tax }) {
  const { addTax, updateTax, loading } = useTax()
  const [taxForm, setTaxForm] = useState({
    name: '',
    taxValue: '',
    taxCode: '',
  })

  const handleAddTax = () => {
    if (tax) {
      updateTax({
        taxId: tax._id,
        name: taxForm.name,
        taxValue: taxForm.taxValue,
        taxCode: taxForm.taxCode,
      })
    } else {
      addTax({
        name: taxForm.name,
        taxValue: taxForm.taxValue,
        taxCode: taxForm.taxCode,
      })
    }
  }

  useEffect(() => {
    if (tax) {
      setTaxForm({
        ...taxForm,
        name: tax.name,
        taxValue: tax.taxValue,
        taxCode: tax.taxCode,
      })
    }
  }, [tax])

  return (
    <Layout heading="Tax" heading2={tax ? 'Edit' : 'Add'} url1={ROUTES.TAX} none>
      <HeaderTabLayout
        heading={`${tax ? 'Edit' : 'Add'} Tax`}
        content={<TaxForm form={taxForm} setForm={setTaxForm} />}
        addContent={handleAddTax}
        redirect={ROUTES.TAX}
        loading={loading}
        state={taxForm}
        setState = {setTaxForm}
      />
    </Layout>
  )
}
